import { Reducer } from '@reduxjs/toolkit';

const setForceRenderReducer: Reducer = (state, { payload }) => ({
  ...state,
  forceRender: payload,
});

export default setForceRenderReducer;
